// extracted by mini-css-extract-plugin
export default {"body":"AllMajorBK_body__QXrIL"};